import { useParams, useNavigate } from 'react-router-dom';
import { Card, Descriptions, Avatar, Spin, Tag } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import { useUserDetails } from '../hooks/useUserDetails';
import { formatDateTime } from '@/shared/utils/formatters';

export default function UserDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data, isLoading } = useUserDetails(id);

  if (isLoading) return <Spin style={{ display: 'block', margin: '80px auto' }} />;
  if (!data) return <Card><p>{t('users.notFound')}</p></Card>;

  return (
    <div>
      <PageHeader back
        title={t('users.detailsTitle')}
        subtitle={`${data.firstName || ''} ${data.lastName || ''}`}
        actionLabel={t('common.edit')}
        onAction={() => navigate(`/users/${id}/edit`)}
      />
      <Card>
        <Descriptions column={{ xs: 1, sm: 2, md: 3 }} bordered size="small">
          <Descriptions.Item label={t('common.id')}>{data.id}</Descriptions.Item>
          <Descriptions.Item label={t('users.email')}>
            <span data-allstak-mask data-sensitive>{data.email || '—'}</span>
          </Descriptions.Item>
          <Descriptions.Item label={t('users.phone')}>
            <span data-allstak-mask data-sensitive>
              {data.phoneNumber ? `${data.phonePrefix || ''}${data.phoneNumber}` : '—'}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label={t('users.verified')}>
            <Tag color={data.isPhoneVerified ? 'green' : 'red'}>{data.isPhoneVerified ? t('common.yes') : t('common.no')}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label={t('users.gender')}>{data.gender || '—'}</Descriptions.Item>
          <Descriptions.Item label={t('users.language')}>{data.language || '—'}</Descriptions.Item>
          <Descriptions.Item label={t('users.occupation')}>{data.occupationType || '—'}</Descriptions.Item>
          <Descriptions.Item label={t('users.dateOfBirth')}>{data.dateBrith || '—'}</Descriptions.Item>
          <Descriptions.Item label={t('users.nationality')}>
            {data.nationalityName ? `${data.nationalityName} (#${data.nationalityId})` : '—'}
          </Descriptions.Item>
          <Descriptions.Item label={t('users.referral')}>
            {data.referralName ? `${data.referralName} (#${data.referralId})` : '—'}
          </Descriptions.Item>
          <Descriptions.Item label={t('users.showAge')}>{data.showAge ? t('common.yes') : t('common.no')}</Descriptions.Item>
          <Descriptions.Item label={t('common.status')}>
            <Tag color={data.isDeleted ? 'red' : 'green'}>{data.isDeleted ? t('users.archived') : t('common.active')}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label={t('users.lastLogin')}>{formatDateTime(data.lastLogin)}</Descriptions.Item>
          <Descriptions.Item label={t('common.createdAt')}>{formatDateTime(data.createdAt)}</Descriptions.Item>
          <Descriptions.Item label={t('common.updatedAt')}>{formatDateTime(data.updatedAt)}</Descriptions.Item>
        </Descriptions>
        {data.avatar && (
          <div style={{ marginTop: 24 }}>
            <Avatar src={data.avatar} size={80} />
          </div>
        )}
      </Card>
    </div>
  );
}
